/**
 * Turns things like 'Róemenië' into 'Roemenie'.
 */
export function transliterate(input: string) {
	return input
		.normalize('NFD') // split letters and diacritics
		.replace(/[\u0300-\u036f]/g, ''); // remove diacritical marks
}

export function withNonBreakingSpaces(input: string) {
	return input.replace(new RegExp(' ', 'g'), '\u00A0');
}

export function hasEmoji(str: string) {
	// This unicode RegEx flag is supported by almost all (modern) browsers (https://caniuse.com/?search=%5Cp)
	// More info about the Emoji selector: https://unicode.org/reports/tr51/#def_emoji_character
	// Since we will only use this function for validation, this should suffice until we encounter any further issues.
	// The worst thing that can happen is that we don't show a message when the text does contain an Emoji.
	// Note that we use the new RegExp() notation, this is because during compilation the u flag is cut off, so don't
	// touch it!
	try {
		return new RegExp('\\p{Emoji}', 'u').test(str);
	} catch {
		return false;
	}
}
